import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ProcessSection from './components/ProcessSection';
import CTASection from './components/CTASection';
import ProgrammingServices from './components/ProgrammingServices';
import SupportedPlatformsSection from './components/SupportedPlatformsSection';
import CertifiedExpertise from './components/CertifiedExpertise';
import SEO from '../../components/base/SEO';


export default function ProgrammingPage() {
  return (
    <div className="min-h-screen bg-white dark:bg-slate-900 transition-colors duration-300">
      <SEO 
        title="Programming Services | Drafting By DMI"
        description="Expert programming for the industry's most reliable control platforms. Comprehensive programming solutions for your AV integration."
        url={window.location.href}
      />
      <Header />
      <main>
        <ProgrammingServices />
        <SupportedPlatformsSection />
        <CertifiedExpertise />
        <ProcessSection serviceType="takeoff" /> {/* Reusing takeoff process as it's generic enough or matches the workflow */}
        <CTASection serviceType="takeoff" />
      </main>
      <Footer />
    </div>
  );
}
